import requestUtils from 'api/requestUtils'
import type { paths } from '@luxuryescapes/contract-svc-merchandise'

type SellersResponse = paths['/api/merchandise/sellers']['get']['responses']['200']['content']['application/json']
type ServerSeller = SellersResponse['result']['sellers'][number]

function mapSeller(seller: ServerSeller): App.MerchandiseOfferSeller {
  return {
    id: seller.id,
    name: seller.businessName,
    emailAddress: seller.emailAddress,
    shipping: {
      minDays: seller.shippingSLA?.minimum ?? 0,
      maxDays: seller.shippingSLA?.maximum ?? 0,
    },
    returnPolicy: seller.returnPolicy ?? undefined,
    shippingPolicy: seller.shippingPolicy ?? undefined,
    servicePolicy: seller.servicePolicy ?? undefined,
    domesticShippingFreeThreshold: seller.domesticShippingFreeThreshold ?? undefined,
  }
}

function getMerchandiseSellers(ids: Array<string>): Promise<Array<App.MerchandiseOfferSeller>> {
  const params = new URLSearchParams({ ids: ids.join(',') })

  return requestUtils
    .get<SellersResponse>(`/api/merchandise/sellers?${params}`)
    .then((response) => response.result.sellers.map(mapSeller))
}

export default getMerchandiseSellers
